import { Command, EditorState } from "prosemirror-state";
import { clearStyles } from "../commands/clearStyles";
import { useMemo } from "react";

export type EraserToolHandlers = {
	canErase: boolean;
	eraseHandler: () => void;
};

export function useEraserTool(
	state: EditorState,
	applyCommand: (command: Command) => void,
	focus?: () => void
): EraserToolHandlers {

	const command = useMemo(
		(): Command => {
			return clearStyles(state.schema);
		},
		[state.schema]
	);

	return {
		canErase: command(state),
		eraseHandler: (): void => {
			applyCommand(command);
			focus?.();
		}
	};
}